import { call, put, takeLatest } from "redux-saga/effects";

import { makePayload, generateDefaultActions, requestSaga } from "../../shared-utility/store/utils/helpers";
import { ToastSuccess, ToastError } from "../../components/Global/Toasts/Toasty";
import { authorizedRequest } from "../../utils/api";

const GET_ACCOUNTING_INTEGRATIONS_FOR_MODEL = generateDefaultActions("GET_ACCOUNTING_INTEGRATIONS_FOR_MODEL");
export const getAccountingIntegrationsForModel = (modelName, modelId) => makePayload(GET_ACCOUNTING_INTEGRATIONS_FOR_MODEL.value, { modelName, modelId });
function* getAccountingIntegrationsForModelSaga(payload) {
  yield requestSaga(GET_ACCOUNTING_INTEGRATIONS_FOR_MODEL, `/accountingIntegrations/models/${payload.modelName}/${payload.modelId}`);
}

const GET_ACCOUNTING_INTEGRATIONS_FOR_DEAL = generateDefaultActions("GET_ACCOUNTING_INTEGRATIONS_FOR_DEAL");
export const getAccountingIntegrationsForDeal = dealId => makePayload(GET_ACCOUNTING_INTEGRATIONS_FOR_DEAL.value, { dealId });
function* getAccountingIntegrationsForDealSaga(payload) {
  yield requestSaga(GET_ACCOUNTING_INTEGRATIONS_FOR_DEAL, `/accountingIntegrations/deals/${payload.dealId}`);
}

const CREATE_ACCOUNTING_INTEGRATION = generateDefaultActions("CREATE_ACCOUNTING_INTEGRATION");
export const createAccountingIntegration = (path, modelId, valueFieldId, sourceFileId, dealId) => makePayload(CREATE_ACCOUNTING_INTEGRATION.value, { path, modelId, valueFieldId, sourceFileId, dealId });
function* createAccountingIntegrationSaga(payload) {
  yield requestSaga(CREATE_ACCOUNTING_INTEGRATION, "/accountingIntegrations", "POST", payload);
}

const DELETE_ACCOUNTING_INTEGRATION = generateDefaultActions("DELETE_ACCOUNTING_INTEGRATION");
export const deleteAccountingIntegration = accountingIntegrationId => makePayload(DELETE_ACCOUNTING_INTEGRATION.value, { accountingIntegrationId });
function* deleteAccountingIntegrationSaga(payload) {
  try {
    const response = yield call(authorizedRequest, `/accountingIntegrations/${payload.accountingIntegrationId}`, "DELETE");
    yield put({ type: DELETE_ACCOUNTING_INTEGRATION.success, payload: response, originalPayload: payload });

    return { error: false };
  } catch (error) {
    yield put(DELETE_ACCOUNTING_INTEGRATION.createFailure(error));

    return { error: true };
  }
}

const initialState = {
  items: undefined,
  dealItems: undefined
};

export function accountingIntegrationReducer(state = initialState, action) {
  const { type, payload, originalPayload } = action;
  switch (type) {
    case GET_ACCOUNTING_INTEGRATIONS_FOR_MODEL.success:
      return { ...state, items: payload.data };

    case GET_ACCOUNTING_INTEGRATIONS_FOR_DEAL.success:
      return { ...state, dealItems: payload.data };

    case CREATE_ACCOUNTING_INTEGRATION.success:
      ToastSuccess("Successfully saved accounting integration");

      return { ...state, items: [...state.items, payload.data], dealItems: state.dealItems ? [...state.dealItems, payload.data] : undefined };

    case DELETE_ACCOUNTING_INTEGRATION.success:
      ToastSuccess("Successfully removed accounting integration");

      return {
        ...state,
        items: state.items.filter(item => item.id !== originalPayload.accountingIntegrationId),
        dealItems: state.dealItems ? state.dealItems.filter(item => item.id !== originalPayload.accountingIntegrationId) : undefined
      };

    case CREATE_ACCOUNTING_INTEGRATION.failure:
      ToastError("Failed to save accounting integration");

      return { ...state };

    case DELETE_ACCOUNTING_INTEGRATION.failure:
      ToastError("Failed to removed accounting integration");

      return { ...state };

    case GET_ACCOUNTING_INTEGRATIONS_FOR_MODEL.failure:
      ToastError("Failed to get accounting integrations");

      return { ...state };

    case GET_ACCOUNTING_INTEGRATIONS_FOR_DEAL.failure:
      ToastError("Failed to get accounting integrations for deal");

      return { ...state };

    default:
      return state;
  }
}

export function* accountingIntegrationSaga() {
  yield takeLatest(GET_ACCOUNTING_INTEGRATIONS_FOR_MODEL.value, getAccountingIntegrationsForModelSaga);
  yield takeLatest(GET_ACCOUNTING_INTEGRATIONS_FOR_DEAL.value, getAccountingIntegrationsForDealSaga);
  yield takeLatest(CREATE_ACCOUNTING_INTEGRATION.value, createAccountingIntegrationSaga);
  yield takeLatest(DELETE_ACCOUNTING_INTEGRATION.value, deleteAccountingIntegrationSaga);
}
